<template>
    <div :class="'h-full text-center box is-shadowless is-flex-grow-1 is-flex is-flex-direction-column ' + product + ' ' + location"
        :style="is_zopim ? 'width:86%' : ''">

        <div v-if="!is_registered && location == 'ticket_editor'" class="is-flex is-flex-grow-1">&nbsp;</div>



        <div v-if="user_not_provisionned" class="preStuff mt-4">
            <p class="text-sm text-gray-500">Your Birdie account is not provisioned yet.</p>
        </div>



        <div v-else-if="is_loading" class="preStuff mt-6 mb-4">
            <!-- <b-spinner variant="secondary" small label="Loading…"></b-spinner> -->
            <spinner class="mx-auto h-5 w-5 text-gray-500"></spinner>
        </div>
        <!-- <div v-else-if="has_match_error" :class="[is_zopim ? '' : 'mt-6 mb-4', 'preStuff']">
            <p><vue-feather type="alert-triangle" class="h-4 w-4 mr-2"></vue-feather> Security error: Zendesk and Birdie
                accounts do not match.</p>
            <p class="mt-4">You should uninstall this app and reinstall it with an Admin profile.</p>
        </div> -->
        <div v-else-if="must_reconnect" :class="[is_zopim ? '' : 'mt-6 mb-4', 'preStuff']">
            <p><vue-feather type="alert-triangle" class="h-4 w-4 mr-2"></vue-feather> Auth error: Zendesk API token is
                not
                valid anymore.</p>
            <p class="mt-4">You must reconnect with Birdie with an Admin profile.</p>
            <a v-if="!signingin" class="button is-link mt-4" :href="login_url" target="_blank"
                @click="connectLinkClicked">
                <span>Reconnect</span>
                <span class="icon is-small">
                    <vue-feather type="external-link" class="h-4 w-4 ml-2"></vue-feather>
                </span>
            </a>
            <div v-else class="refresh text-center has-background-white">
                <p>Refresh your browser once Zendesk is successfully connected to your Birdie account.
                </p>
                <p><img src="/img/zendesk-refresh.png" width="220" class="mx-auto mt-2" /></p>
            </div>
        </div>
        <div v-else-if="!is_registered && agent_role != 'admin'" :class="[is_zopim ? '' : 'mt-6 mb-4',
        location == 'ticket_sidebar' ? 'mt-1 mb-4' : 'mt-6 mb-4',
            'preStuff text-center']">
            <p>You must connect to your Birdie account to complete installation.</p>
            <p>&nbsp;</p>
            <p>Actually you are using Zendesk with this role: <code>{{ agent_role }}</code>. You must use an
                <code>admin</code> role account the first time you connect with Birdie.
            </p>
        </div>
        <div v-else-if="!is_registered && !has_zest_account" :class="[is_zopim ? 'text-sm' : '',
        location == 'ticket_sidebar' ? 'mt-1 mb-4' : 'mt-6 mb-4',
            'preStuff']">
            <p v-if="!signingin">Connect to your Birdie workspace to complete installation</p>
            <a v-if="!signingin" class="button is-link mt-4" :href="login_url" target="_blank"
                @click="connectLinkClicked">
                <span>Connect</span>
                <span class="icon is-small">
                    <vue-feather type="external-link" class="h-4 w-4 ml-2"></vue-feather>
                </span>
            </a>
            <div v-else class="refresh text-center has-background-white">
                <p>Refresh your browser once Zendesk is successfully connected to your Birdie account.
                </p>
                <p><img src="/img/zendesk-refresh.png" width="220" class="mx-auto mt-2" /></p>
            </div>
        </div>
        <div v-else-if="!is_registered && has_zest_account && !has_zest_integration" class="preStuff mt-6 mb-4">
            <p v-if="!signingin">You must terminate installation by connecting Zendesk to your Birdie
                account</p>
            <a v-if="!signingin" class="button is-link mt-4" :href="login_url" target="_blank"
                @click="connectLinkClicked">
                <span>Connect</span>
                <span class="icon is-small">
                    <vue-feather type="external-link" class="h-4 w-4 ml-2"></vue-feather>
                </span>
            </a>
            <div v-else class="refresh text-center has-background-white">
                <p>Refresh your browser once Zendesk is successfully connected to your Birdie account.
                </p>
                <p><img src="/img/zendesk-refresh.png" width="220" class="mx-auto mt-2" /></p>
            </div>
        </div>

        <div v-else class="stuffContainer">

            <div v-if="location == 'chat_sidebar'" class="relative">

                <div class="column px-0 py-0 is-full has-text-left sidebarlist">

                    <a href="#" v-if="agents_can != 'send' && agents_can != 'none'" title="Request a recording"
                        class="action ask py-3" @click.prevent="ask_for_a_recording()">
                        <div class="block" v-if="!ask_recording_loading">
                            <strong>Request a recording</strong>
                        </div>
                        <div class="block" v-else>
                            <spinner class="mx-auto h-5 w-5 text-gray-500"></spinner>
                        </div>
                    </a>
                    <a v-else disabled title="Request a recording" class="action ask py-3" style="opacity:0.5">
                        <div class="block">
                            <strong>Request a recording (disabled)</strong>
                        </div>
                    </a>

                    <a v-if="agents_can != 'request' && agents_can != 'none'" :href="send_recording_url"
                        @click="send_a_recording" title="Send a recording" class="action record py-3" target="_blank">
                        <div class="block">
                            <strong>Send a recording</strong>
                        </div>
                    </a>
                    <a v-else disabled title="Send a recording" class="action record py-3" style="opacity:0.5">
                        <div class="block">
                            <strong>Send a recording (disabled)</strong>
                        </div>
                    </a>

                    <a v-if="has_cobrowsing" :href="cobrowsingLink" title="Start CoBrowsing"
                        class="action cobrowse py-3" target="_blank">
                        <div class="block">
                            <strong>Start CoBrowsing</strong>
                        </div>
                    </a>
                    <a v-else-if="false" href="#" @click.prevent.stop title="CoBrowsing" class="action cobrowse py-3">
                        <div class="block">
                            <span class="text-gray-600">CoBrowsing • disabled</span>
                        </div>
                    </a>



                </div>
                <div v-if="!chat_started"
                    class="absolute w-full h-full flex justify-center items-center top-0 bg-white bg-opacity-90 text-sm">
                    User has gone offline.</div>
            </div>

            <div v-else-if="location == 'ticket_sidebar'">

                <div class="column px-0 py-0 is-full has-text-left sidebarlist">

                    <a href="#" v-if="agents_can != 'send' && agents_can != 'none'" title="Request a recording"
                        class="action ask py-3" @click.prevent="ask_for_a_recording()">
                        <div class="block" v-if="!ask_recording_loading">
                            <strong>Request a recording</strong>
                        </div>
                        <div class="block" v-else>
                            <spinner class="mx-auto h-5 w-5 text-gray-500"></spinner>
                        </div>
                    </a>
                    <a v-else disabled title="Request a recording" class="action ask py-3" style="opacity:0.5">
                        <div class="block">
                            <strong>Request a recording (disabled)</strong>
                        </div>
                    </a>

                    <a v-if="agents_can != 'request' && agents_can != 'none'" :href="send_recording_url"
                        title="Send a recording" @click="send_a_recording" class="action record py-3" target="_blank">
                        <div class="block">
                            <strong>Send a recording</strong>
                        </div>
                    </a>
                    <a v-else disabled title="Send a recording" class="action record py-3" style="opacity:0.5">
                        <div class="block">
                            <strong>Send a recording (disabled)</strong>
                        </div>
                    </a>

                    <a v-if="has_cobrowsing" :href="cobrowsingLink" title="Start CoBrowsing"
                        class="action cobrowse py-3" target="_blank">
                        <div class="block">
                            <strong>Start CoBrowsing</strong>
                        </div>
                    </a>
                    <a v-else-if="false" href="#" @click.prevent.stop title="CoBrowsing" class="action cobrowse py-3">
                        <div class="block">
                            <span class="text-gray-600">CoBrowsing • disabled</span>
                        </div>
                    </a>

                    <!-- <div class="block mb-2 mt-4 title">
                    <strong>Recorded by this user:</strong>
                </div>
                <div class="block mb-2 novideo has-text-grey ml-2" v-if="user_videos.length==0">
                    no video yet
                </div>
                <a v-else v-for="video in user_videos" :key="video.id" :href="video.sharing_link" target="_blank" title="Open in new tab">
                    <div class="block">
                      <strong><span>{{ video.added_diff }}</span><span v-if="video.title">, {{ video.title }}</span></strong>
                    </div>
                    <div class="block has-text-grey ">
                        {{ video.added_duration }} • {{ video.added_date }}
                    </div>
                </a>
                <a v-if="user_videos.length > 0 && next_page>0" @click.prevent="get_videos_from_user()">
                    <div class="block my-2">
                        <span v-if="loading_videos">
                            <spinner class="mx-auto h-5 w-5 text-gray-500"></spinner>
                        </span>
                        <span v-else>
                            + Load more…
                        </span>
                    </div>
                </a> -->

                </div>

            </div>

            <div v-else-if="location == 'ticket_editor'" class="is-flex is-flex-grow-1">

                <div
                    class="column px-0 py-0 is-full has-text-left editor is-flex is-flex-grow-1 is-flex-direction-column is-justify-content-flex-end">

                    <div class="editorPopTitle">Birdie</div>

                    <a :href="'mailto:support@' + domain + '?subject=zendesk-app'" target="_blank"
                        :title="'Send an email to Birdie support'" class="action help pt-3 pb-1 has-text-right">
                        <div class="block">
                            <strong>Get help</strong>
                        </div>
                    </a>



                    <a href="#" title="Request a recording" class="action ask py-3"
                        @click.prevent="ask_for_a_recording()"
                        v-if="Object.keys(requester).length > 0 && agents_can != 'send'">
                        <div class="block">
                            <strong>Request a recording</strong>
                        </div>
                    </a>
                    <a title="Request a recording" class="action ask py-3" v-else-if="Object.keys(requester).length > 0"
                        style="opacity:0.5">
                        <div class="block">
                            <strong>Request a recording (disabled)</strong>
                        </div>
                    </a>


                    <a :href="send_recording_url" title="Send a recording"
                        :class="!show_error_send ? 'action record py-3' : 'action record py-3 error_send has-background-warning'"
                        v-if="Object.keys(requester).length > 0 && agents_can != 'request' && agents_can != 'none'"
                        target="_blank" :style="(!is_zopim && ticket.id) || show_error_send ? '' : 'opacity:0.5'"
                        @click="send_a_recording">
                        <div class="block" v-if="!show_error_send">
                            <strong>Send a recording</strong>
                        </div>
                        <div class="tag is-warning mx-auto" v-else>
                            <span class="">You must submit the ticket before using this action</span>
                        </div>
                    </a>

                    <a title="Send a recording" class="action record py-3" v-else-if="Object.keys(requester).length > 0"
                        style="opacity:0.5">
                        <div class="block">
                            <strong>Send a recording (disabled)</strong>
                        </div>
                    </a>

                    <div class="action no_requester px-3 py-4 has-text-grey"
                        v-else-if="agents_can != 'request' && agents_can != 'none'">
                        Before using Birdie you need to add a recipient or requester to this ticket…
                    </div>

                    <a v-if="has_cobrowsing" :href="cobrowsingLink" title="Start CoBrowsing"
                        class="action cobrowse py-3" target="_blank">
                        <div class="block">
                            <strong>Start CoBrowsing</strong>
                        </div>
                    </a>
                    <a v-else-if="false" href="#" title="CoBrowsing" @click.prevent.stop class="action cobrowse py-3">
                        <div class="block">
                            <span class="text-gray-600">CoBrowsing • disabled</span>
                        </div>
                    </a>

                </div>

            </div>






        </div>

        <div class="helpfooter" v-if="location == 'ticket_sidebar' || location == 'chat_sidebar'">Get help at
            <a :href="'mailto:support@birdie.so?subject=zendesk-app'"
                :title="'Send an email to Birdie support'">support@birdie.so</a>

        </div>


    </div>
</template>



<script>

import { debounce } from "debounce";

// const WebSocket = require("ws");
// const ACCESS_TOKEN = "b89d7a38b9dcbae43b8ebb522d04ec93e7a7412433fb2fbbf6f2c03930835779";
// const CHAT_API_URL = "https://chat-api.zopim.com/graphql/request";


import {

    //onAppActivated,onAppExpanded,onPaneActivated, getTicketId, sendMessage, setTag,
    //getTicket,getTicketComment,getTicketBrand,getTicketIsNew,getTicketFields,
    // onChatStart,onChatEnd, sendChat, getTicketFieldRequest, insertCommentMarkdown,

    //sendButtonTemplate, editorInsertLink, onTicketSubmitDone, onTicketSave, editorInsertImage,
    setKey, getKey, closePopup, deleteKey,
    getTicketFieldsRequest, setTicketCustomField, hideField, getTicketField,
    insertCommentHtml, insertCommentText,
    getTicketDetails, getChatId,
    getCurrentUser, getTicketRequester,
    getMetadata, getContext, getTicketComments,
    postToChatTextArea,
    getCurrentAccount, getVisitor,
    getChannel, getTicketConversation,
    onTicketChanged, getChannelNameFromEditor,
    sendToInstance, onMessage, editorInsertHtml
} from './zaf';

import Spinner from '@/Components/UI/Spinner'

export default {
    //name: "integration-zendesk",  // using EXACTLY this name is essential

    name: "IntegrationZendesk",

    props: ['product', 'location', 'recsec'],

    components: {
        Spinner,
    },

    created: function () {

        onTicketChanged(this.on_ticket_changed);

        onMessage(this.onMessageReceived);

        // this.$page.props.isz = true;
        // this.$page.props.app_url = 'https://birdie.eu.ngrok.io';

    },

    beforeUnmount() {
        if (this.test_loop) {
            clearTimeout(this.test_loop);
        }
        if (this.show_error_send_timer) {
            clearTimeout(this.show_error_send_timer);
        }
    },

    data() {
        return {
            has_started_auth: false,
            is_loading: true,
            context: {},
            metadata: {},
            is_registered: false,
            has_zest_account: false,
            has_zest_integration: false,
            team_slug: "",
            team_slugname: "",
            integration_id: 0,
            subdomain: "",

            signingin: false,
            show_error_send: false,
            show_error_send_timer: "",

            agent: {},
            //zest_user_id: 0,
            requester: {},

            //brand_name: "",
            //brand_logo: "",

            test_loop: null,
            //should_test_in_loop: false,

            has_match_error: false,
            ticket: {},
            chat_id: "",

            loading_videos: false,
            next_page: 1,
            user_videos: [],

            ask_recording_loading: false,
            send_recording_loading: false,
            tinyurl: "",
            agents_can: "all",
            test: undefined,

            is_zopim: this.location == "chat_sidebar",
            chat_id: null,
            chat_started: true,
            check_chat_timeout: null,
            channel: null,
            domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
            must_reconnect: false,
            zest_identification: null,
            has_cobrowsing: false,
            has_screenrecording: true,
            should_add_birdie_tag: false,
            user_not_provisionned: false,
        }
    },

    mounted: function () {


        this.start_auth();



        //onTicketSubmitDone(this.on_ticket_submit_done);

        // if (this.location == "chat_sidebar") {
        //     onChatStart(this.chat_start)
        //     onChatEnd(this.chat_end)
        // }



        // if (this.location = "ticket_editor") {
        //   onAppActivated(this.app_activated());
        //   onAppExpanded(this.app_expanded());
        //   onPaneActivated(this.pane_activated());
        // }

        // getTicketFields().then((response) => {
        // })
        // getCurrentAccount().then((response) => {
        // })
        // getTicketRequester().then((response) => {
        //   //let toto = JSON.stringify(response);
        //   //let tata = JSON.parse(toto);
        //   console.warn(response["ticket.requester"]);
        //   if (tata.ticket.requester) {
        //     this.requester = response.ticket.requester;
        //   } else {
        //   }
        //   this.get_metadata();
        // });
        //onPaneActivated(this.pane_activated());

    },

    methods: {

        onMessageReceived: function (message) {
            if (this.$page.props.isz) {
                console.log("onMessage", message, "this.channel", this.channel)
            }
            if (message.message?.channel && this.channel == null) {
                // if (message.channel == 'native_messaging') {
                // console.log("onMessage channel is", message.message.channel)
                this.channel = message.message.channel
            }
        },

        setBirdieTag: function () {
            //setTag('birdie')

            if (!this.ticket.id) {
                //console.log("No ticket Id")
                this.should_add_birdie_tag = true
                return
            }

            let url = this.$page.props.app_url + '/zendeskapp/tag/' + this.ticket.id
            //console.log(url)
            var params = {
                integration: this.integration_id,
                secret: this.secret
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data)
                })
                .catch(e => {
                    console.error(e);
                });
        },

        on_ticket_changed: debounce(function (e) {
            if (this.$page.props.isz) {
                console.log("on_ticket_changed", e)
            }
            if (e["propertyName"].substr(0, 17) == "ticket.requester.") {
                getTicketRequester().then((response) => {
                    if (response["ticket.requester"]) {
                        if (this.team)
                            this.requester = response["ticket.requester"];
                    } else {
                        // rien
                    }
                });
            }
            if (e["propertyName"] == "ticket." + this.ticket.custom_field_name) {
                if (e["newValue"] != this.ticket.custom_field_value && this.ticket.custom_field_value != "") {
                    //TODO set it back to this.ticket.custom_field_value
                    setTicketCustomField(this.ticket.custom_field_name, this.ticket.custom_field_value).then((response) => {
                    })
                }
            }
        }, 500),

        ask_for_a_recording: function () {

            if (this.ask_recording_loading) {
                return;
            }

            if (!this.is_zopim && this.ticket.isNew) {
                setTicketCustomField(this.ticket.custom_field_name, this.ticket.randomId).then((response) => {
                })
            }

            if (!this.is_zopim && Object.keys(this.requester).length == 0) {
                console.warn("Birdie needs a ticket recipient")
                return
            }

            //return

            const the_link_base = this.$page.props.app_url.replace(this.$page.props.app_url, "https://" + this.team_slugname + "." + this.domain);

            var the_link = the_link_base + "/recorder";


            // var agentLight = {
            //       id: this.agent.id,
            //       email: this.agent.email,
            //       name: this.agent.name,
            //       locale: this.agent.locale,
            //       isSystemUser: this.agent.isSystemUser,
            //       externalId: this.agent.externalId,
            //       role: this.agent.role,
            //       avatarUrl: this.agent.avatarUrl,
            //       timeZone: {
            //           ianaName: this.agent.timeZone.ianaName
            //       }
            //     }




            if (this.channel == "native_messaging" || this.channel == "api") {
                this.chat_id = this.ticket.id + "_native_messaging"
            }

            if (this.$page.props.isz) {
                console.log("channel", this.channel)
                console.log("ticket.id", this.ticket.id)
                console.log("chat_id", this.chat_id)
            }


            var zep = {
                s1: this.subdomain,
                s2: this.metadata.appId,
                s3: this.metadata.installationId,
                s4: this.ticket.id ? this.ticket.id : 0,
                s4_csname: this.ticket.custom_field_name ? this.ticket.custom_field_name : "",
                s4_csvalue: this.ticket.randomId ? this.ticket.randomId : "",
                s5: null,
                s6: "",
                s7: this.agent.id,
                s8: this.chat_id,
                s9: this.channel
            }

            if (this.$page.props.isz) {
                console.log("zep", zep)
            }

            let reqName = this.requester.name
            if (this.hasNonASCIICharacters(reqName) && this.requester.email) {
                reqName = this.requester.email.split("@")[0]
            }

            if (!this.is_zopim) {
                const requesterLight = {
                    id: this.requester.id,
                    email: this.requester.email,
                    name: reqName,
                    locale: this.requester.locale,
                    isSystemUser: this.requester.isSystemUser,
                    externalId: this.requester.externalId,
                    role: this.requester.role,
                    avatarUrl: this.requester.avatarUrl,
                    timeZone: {
                        ianaName: this.requester.timeZone.ianaName
                    },
                    tags: this.requester.tags?.join(",")
                }
                zep.s5 = JSON.stringify(requesterLight)
                zep.s6 = this.ticket.randomIds
            } else {
                const requesterLight = {
                    id: this.requester.id,
                    email: this.requester.email,
                    name: reqName,
                    //locale: this.requester.locale,
                    //isSystemUser: this.requester.isSystemUser,
                    externalId: this.requester.externalId,
                    tags: this.requester.tags?.join(",")
                    // role: this.requester.role,
                    // avatarUrl: this.requester.avatarUrl,
                    // timeZone: {
                    //     ianaName: this.requester.timeZone.ianaName
                    // }
                }
                zep.s5 = JSON.stringify(requesterLight)
            }


            // if (this.team_slugname == 'zest') {
            //   zep = {
            //     s1: this.subdomain,
            //     s2: this.metadata.appId,
            //     s3: this.metadata.installationId,
            //     s4: this.ticket.id ? this.ticket.id : 0,
            //     s4_csname: "",
            //     s4_csvalue: "",
            //     s5: JSON.stringify({
            //         id: 9193555243933,
            //         email: null,
            //         name: "447472411149",
            //         locale: "en-gb",
            //         isSystemUser: false,
            //         externalId: "bfb7a293f38d44a2a38f45fc62762a83",
            //         role: "end-user",
            //         avatarUrl: "https:\/\/assets.zendesk.com\/images\/2016\/default-avatar-80.png",
            //         timeZone: {
            //           ianaName: "Europe\/London"
            //         }
            //     }),
            //     s6: "",
            //     s7: this.agent.id,
            //     s8: this.chat_id,
            //     s9: "api"
            //   }
            // }

            //return
            zep = btoa(unescape(encodeURIComponent(JSON.stringify(zep))))
            let secure_zep = this.secureCode(zep);
            the_link += "?zep=" + encodeURI(secure_zep);
            //the_link += "&rid=" + this.ticket.randomId;
            if (this.$page.props.app_url.indexOf(".test") >= 0) {
                the_link += "&team=" + this.team_slugname; // DEBUG
            }

            let the_image = this.$page.props.app_url + "/img/rec.png";

            // var markdown = "[![Click here to record your screen]("+the_image+")]("+the_link+")";
            // markdown += "[Click here to record your screen]("+the_link+")";
            // let result = insertCommentMarkdown(markdown);
            // if (result && this.location == 'ticket_editor') {
            //   closePopup();
            // }
            // return;

            var result = null;

            if (this.tinyurl == "") {
                this.ask_recording_loading = true
                this.saveTinyAndSend(the_link)
                return
            }

            const short_link = the_link_base + "/rec/" + this.tinyurl

            if (!this.is_zopim && this.ticket.comment.useRichText == true) {

                if (this.location == 'ticket_editor') {
                    var html = '<a href="' + short_link + '">';
                    html += short_link
                    html += '</a> ';
                    result = editorInsertHtml(html);
                }
                else
                {

                    var html = '<p>';

                    // html += 'Click here to record your screen: ';
                    html += '<a href="' + short_link + '">';
                    //html += the_link;

                    html += short_link

                    html += '</a> ';
                    html += '<br /></p>';

                    result = insertCommentHtml(html);

                }

            } else {

                //const text = 'Click here to record your screen: ' + the_link_base + "/rec/" + this.tinyurl + ' '
                //const text = "Click here to record your screen: " + short_link + " "
                const text = short_link + " "
                if (!this.is_zopim) {
                    if (this.location == 'ticket_editor') {
                        result = editorInsertHtml(short_link);
                    } else {
                        result = insertCommentText(text);
                    }
                } else {
                    result = postToChatTextArea(text);
                }




                if (!this.chat_id && (this.channel == "native_messaging" || this.channel == "api") && this.ticket.id) {
                    this.chat_id = this.ticket.id + "_native_messaging"
                }

                // if (this.chat_id) {
                //     this.start_check_chat_video()
                // }

            }


            if (result && this.location == 'ticket_editor') {
                closePopup();
            }



        },

        secureCode: function (original) {
            let insert = this.recsec;
            if (original.indexOf(insert) >= 0) {
                return original;
            }
            let randomPlace = Math.floor(Math.random() * (original.length - 1));
            return [original.slice(0, randomPlace), insert, original.slice(randomPlace)].join('');
        },

        send_a_recording: function (event) {

            if (!this.chat_id && (this.channel == "native_messaging" || this.channel == "api") && this.ticket.id) {
                this.chat_id = this.ticket.id + "_native_messaging"
            }

            if (this.chat_id) {
                // Remove this as we do not start check chat anymore for sent recordings,
                // they will have only a link to copy...
                // this.start_check_chat_video()
            }
            else if (!this.ticket.id) {
                event.preventDefault();
                clearTimeout(this.show_error_send_timer);
                this.show_error_send = true;
                this.show_error_send_timer = setTimeout(function () {
                    this.show_error_send = false;
                }.bind(this), 3000);
            }
            this.send_recording_loading = false;
        },

        // start_check_chat_video: function () {

        //     clearTimeout(this.check_chat_timeout)

        //     if (this.chat_id) {
        //         this.proceed_check_chat()
        //     }

        //     this.check_chat_timeout = setTimeout(function () {
        //         this.start_check_chat_video()
        //     }.bind(this), 3000)

        // },

        // proceed_check_chat: function () {

        //     let url = this.$page.props.app_url + '/zendeskapp/checkchat/' + this.chat_id
        //     //let url = 'https://zest.eu.ngrok.io/zendeskapp/checkchat/'+this.chat_id
        //     var params = {
        //         integration: this.integration_id,
        //         secret: this.secret
        //     };
        //     axios.post(url, params)
        //         .then(response => {
        //             if (response.data) {
        //                 if (response.data.length > 0) {
        //                     // if (this.team_slugname == 'zest') {
        //                     //   console.log('proceed_check_chat', response.data)
        //                     // }

        //                     // in all cases add birdie tag
        //                     this.setBirdieTag()

        //                     for (var v = 0; v < response.data.length; v++) {
        //                         const video = response.data[0]
        //                         const the_channel = this.chat_id.endsWith("_native_messaging") ? "messaging" : "chat"
        //                         if (video.user_id != null) {
        //                             if (this.is_zopim) {
        //                                 result = postToChatTextArea(video.sharing_link);
        //                             } else {
        //                                 result = sendMessage(the_channel, video.sharing_link);
        //                             }
        //                         } else {
        //                             if (this.is_zopim) {
        //                                 if (this.$page.props.isz) {
        //                                     console.log("sendChat")
        //                                 }
        //                                 result = sendChat("Video recorded: " + video.sharing_link);
        //                             } else {
        //                                 result = sendMessage(the_channel, "Video recorded: " + video.sharing_link);
        //                             }
        //                         }
        //                     }

        //                 }
        //             }

        //         })
        //         .catch(e => {
        //             console.error(e);

        //         });
        // },


        start_auth: function () {
            if (!this.has_started_auth) {
                this.has_started_auth = true;
                if (this.is_zopim) {
                    this.channel = "zopim_chat" // useless
                    this.get_context()
                } else {
                    this.get_channel();
                }
            }
            return
        },
        isValidJson: function (str) {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        },
        get_channel: function () {

            if (this.location == 'ticket_editor') {
                getChannelNameFromEditor().then((channel) => {

                    if (this.$page.props.isz) {
                        console.log("getChannelEditor", channel)
                    }

                    //console.log("********** getChannelEditor **********", this.$page.props.isz, channel)

                    if (typeof channel === 'string') {
                        if (this.isValidJson(channel)) {
                            channel = JSON.parse(channel)
                        }
                    }

                    if (typeof channel === 'string') {
                        this.channel = channel
                    } else if (channel instanceof Object) {
                        if (channel['ticket.editor.targetChannel.name']) {
                            this.channel = channel['ticket.editor.targetChannel.name']
                        } else {
                            this.channel = channel.ticket?.editor?.targetChannel?.name ?? "internal"
                        }
                    }

                    if (this.$page.props.isz) {
                        console.log("getChannelNameFromEditor", channel, this.channel)
                    }

                    this.get_context()

                    if (this.channel == 'native_messaging' || this.channel == 'api') {
                        setTimeout(() => {
                            sendToInstance('ticket_sidebar', { channel: this.channel })
                        }, 500)
                    }

                    if (this.channel == "chat" || this.channel == "native_messaging" || this.channel == "api") {
                        this.get_conversation()
                    }
                });
            } else {

                getChannel().then((channel) => {
                    if (this.$page.props.isz) {
                        console.log("getChannel", channel)
                    }
                    const channelWasNull = this.channel == null
                    if (channel.channel.name && this.channel == null) { // && channel.channel.name != "chat") {
                        this.channel = channel.channel.name
                    }
                    this.get_context()

                    if (this.location == 'ticket_sidebar') {

                        if (channelWasNull && this.channel == 'native_messaging' || this.channel == 'api') {
                            setTimeout(() => {
                                sendToInstance('ticket_editor', { channel: this.channel })
                            }, 500)
                        }

                        this.get_conversation()
                    }
                });
            }
        },

        get_conversation: function () {
            getTicketConversation().then((conversation) => {
                const conversation_string = JSON.stringify(conversation)
                if (conversation_string.includes("share.birdie.so")) {
                    this.setBirdieTag()
                }
                // if (conversation_string.includes(this.domain + "/rec")) {
                //     this.start_check_chat_video()
                // }
            });
        },

        get_context: function () {
            getContext().then((context) => {
                this.context = context;
                if (this.$page.props.isz) {
                    console.log("get_context", context)
                }
                //this.is_zopim = context.location == "chat_sidebar"
                if (!this.is_zopim) {
                    this.subdomain = context.account.subdomain
                    // RUBIKO DEBUG
                    if (this.subdomain == "rubiko") {
                        this.subdomain = "support"
                    }
                    this.get_metadata()
                } else {
                    this.get_current_account()
                }
            });
        },

        get_current_account: function () {
            getCurrentAccount().then((response) => {
                this.subdomain = response.currentAccount.zendesk
                // RUBIKO DEBUG
                if (this.subdomain == "rubiko") {
                    this.subdomain = "support"
                }
                this.get_metadata()
            })
        },



        get_metadata: function () {
            getMetadata().then((metadata) => {
                if (this.$page.props.isz) {
                    console.log("get_metadata", metadata)
                }
                this.metadata = metadata;
                if (!this.is_zopim) {
                    this.get_ticket_fields()
                } else {
                    this.get_current_user()
                }
            })
        },

        get_ticket_fields: function () {
            // if (this.metadata.installationId == 360006763939 || true) {
            getTicketFieldsRequest().then((response) => {
                this.test = response
                var responseJson = response.responseJSON
                for (var i = 0; i < responseJson.ticket_fields.length; i++) {
                    if (responseJson.ticket_fields[i].title == "zest_id") {
                        this.ticket.custom_field_name = "custom_field_" + responseJson.ticket_fields[i].id;
                        this.ticket.custom_field_value = "";
                        hideField(this.ticket.custom_field_name);
                        break
                    }
                }

                if (this.ticket.custom_field_name) {
                    getTicketField(this.ticket.custom_field_name).then((response) => {
                        this.ticket.custom_field_value = response["ticket.customField:" + this.ticket.custom_field_name];
                        this.get_current_user();
                    })
                } else {
                    this.get_current_user();
                }
            })

        },
        get_current_user: function () {
            getCurrentUser().then((currentUser) => {
                this.agent = currentUser.currentUser; //["currentUser"];

                if (this.is_zopim) {
                    this.agent.timeZone = { ianaName: null }
                    this.get_chat_id()
                } else {
                    this.get_requester()
                }
            });
        },
        get_chat_id: function () {
            getChatId().then((response) => {
                this.chat_id = response["chat.id"]
                this.get_requester()
            })
        },
        get_requester: function () {
            if (this.is_zopim) {
                getVisitor().then((response) => {
                    this.requester = response["visitor"]
                    this.get_identification()
                })
            } else {
                getTicketRequester().then((response) => {
                    if (response["ticket.requester"]) {
                        this.requester = response["ticket.requester"]
                    }
                    this.get_identification()
                })
            }
        },
        get_identification: function () {
            getKey("zest_identification-agent_" + this.agent.id).then((value) => {
                if (value) {
                    const parsed = JSON.parse(value)
                    if (parsed) {
                        this.zest_identification = parsed
                        if (parsed.team_slug && parsed.team_slugname) {
                            this.has_zest_account = true
                            this.team_slug = parsed.team_slug
                            this.team_slugname = parsed.team_slugname
                        }
                        if (parsed.integration) {
                            this.has_zest_integration = true
                            this.integration_id = parsed.integration
                            this.get_zest_settings()
                        }

                        if (this.has_zest_account && this.has_zest_integration) {
                            this.is_registered = true
                        }
                    }
                }

                //if (Object.keys(this.context).length == 0 && !this.is_zopim) {
                if (!this.is_zopim) {
                    this.get_ticket_details()
                } else {
                    this.connection_test()
                }
            }).catch((e) => { console.error("get_identification error", e) })
        },
        get_ticket_details: function () {
            getTicketDetails().then((details) => {
                if (this.$page.props.isz) {
                    console.log("get_ticket_details", details)
                }
                this.ticket.comment = details["ticket.comment"];
                this.ticket.brand = details["ticket.brand"];
                this.ticket.isNew = details["ticket.isNew"];
                this.ticket.randomId = "";
                this.ticket.id = 0;
                if (this.ticket.isNew) {
                    this.ticket.randomId = this.randomId();
                    if (this.ticket.custom_field_name) {
                        setTicketCustomField(this.ticket.custom_field_name, this.ticket.randomId).then((response) => { })
                    }
                }
                if (details["ticket.id"]) {
                    this.ticket.id = details["ticket.id"];
                    if (this.should_add_birdie_tag) {
                        this.setBirdieTag()
                    }
                }
                this.connection_test();
            }).catch((e) => {
                console.error("getTicketDetails error", e)
            });


            //console.log("Channel", this.channel)

            if (this.channel == "native_messaging" || this.channel == "api") {
                this.chat_id = this.ticket.id + "_native_messaging"
            } else {
                getTicketComments().then((details) => {

                    let theList = JSON.parse(JSON.stringify(details))
                    for (var i = 0; i < theList["ticket.comments"].length; i++) {
                        let comment = theList["ticket.comments"][i]
                        if (comment.via.channel == "chat") {
                            if (comment.value.search("Chat started:") > 0
                                && comment.value.search("Chat ID:") > 0
                                && comment.value.search("chat transcript") > 0) {
                                let temp = comment.value.split("Chat ID:")
                                let temp2 = temp[1].split("<", 2)
                                //let chat_id = temp2[0].trim()
                                this.chat_id = temp2[0].trim()
                                break
                            }
                        }
                    }
                }).catch((e) => { console.error("getTicketComments error", e) });

            }
            /*getTicketComment().then((comment) => {
              this.ticket.comment = comment["ticket.comment"]
              getTicketBrand().then((brand) => {
                this.ticket.brand = brand["ticket.brand"]
                getTicketIsNew().then((isNew) => {
                  this.ticket.isNew = isNew["ticket.isNew"]
                  this.ticket.randomId = this.randomId()
                  if (this.ticket.isNew == false) {
                    getTicketId().then((id) => {
                      this.ticket.id = id["ticket.id"]
                      if (!this.is_registered) {
                        this.connection_test();
                      }
                    });
                  } else {
                    // if (this.location == 'ticket_editor') {
                    //   onTicketSubmitDone(this.on_ticket_submit_done);
                    //   //onTicketSave(this.on_ticket_save);
                    // }
                    if (!this.is_registered) {
                      this.connection_test();
                    }
                  }
                });
              });
            });*/
            /*getTicket().then((ticket) => {
              if (ticket.ticket) {
                this.ticket = ticket.ticket;

                if (ticket.ticket.brand) {
                  if (ticket.ticket.brand.name) {
                    this.brand_name = ticket.ticket.brand.name
                  }
                  if (ticket.ticket.brand.logo) {
                    this.brand_logo = ticket.ticket.brand.logo.contentUrl
                  }
                }
              }
              if (!this.is_registered) {
                this.connection_test();
              }
            });*/
        },
        randomId: function () {
            return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        },
        connectLinkClicked: function (e) {
            this.signingin = true;
            //this.should_test_in_loop = true;
            //this.connection_test();
        },
        get_zest_settings: function () {
            if (this.has_zest_integration) {
                let url = this.$page.props.app_url + '/zendeskapp/settings'
                var params = {
                    integration: this.integration_id,
                    secret: this.secret
                };
                if (this.agent) {
                    if (this.agent.email) {
                        params.email = this.agent.email
                    }
                }
                if (this.is_zopim) {
                    params.zopim = "zopim"
                }
                axios.post(url, params)
                    .then(response => {
                        if (response.data) {

                            if (response.data.user_not_provisionned) {
                                this.user_not_provisionned = true
                            }

                            if (response.data.agents_can) {
                                this.agents_can = response.data.agents_can
                            }

                            this.has_cobrowsing = response.data.has_cobrowsing ?? false
                            this.has_screenrecording = response.data.has_screenrecording ?? true
                            if (!this.has_screenrecording) {
                                this.agents_can = 'none'
                            }

                            // debug when changed the team slugname server side
                            if (response.data.team_slugname) {
                                if (this.team_slugname != response.data.team_slugname) {
                                    this.team_slugname = response.data.team_slugname
                                    if (this.zest_identification != null) {
                                        this.zest_identification.team_slugname = response.data.team_slugname
                                        if (this.agent.id) {
                                            setKey("zest_identification-agent_" + this.agent.id,
                                                JSON.stringify(this.zest_identification)
                                            ).then((result) => {
                                                // ok
                                            })
                                        }
                                    }
                                }
                            }


                        }
                    })
                    .catch(e => {
                        console.error(e);
                        if (e.response.status == 400) {
                            this.must_reconnect = true
                            deleteKey("zest_identification-agent_" + this.agent.id).then((result) => {
                                // ok
                            })
                        }
                        if (e.response.status == 403) {
                            //console.log("Zendesk Token is not valid anymore")
                            this.must_reconnect = true
                            // Zendesk Token is not valid anymore
                        }
                    });
            }
        },
        // token_test: function () {
        //     if (this.subdomain != "d3v-zest") {
        //         return
        //     }
        //     let url = this.$page.props.app_url + '/zendeskapp/test/' + this.subdomain
        //     var params = {
        //         secret: this.secret,
        //         tid: this.ticket.id,
        //         rid: this.ticket.custom_field_value
        //     };
        //     if (this.is_zopim) {
        //         params.zopim = "zopim"
        //     }
        //     axios.post(url, params)
        //         .then(response => {
        //             if (response.data) {
        //                 this.is_registered = true
        //             }
        //         })
        //         .catch(e => {
        //             console.error(e);
        //             this.is_registered = false
        //             //this.has_match_error = true;
        //             // this.is_loading = false;
        //             // if (this.should_test_in_loop) {
        //             //     this.test_loop = setTimeout(function() {
        //             //         this.connection_test();
        //             //     }.bind(this), 5000);
        //             // }
        //         });
        // },
        connection_test: function (_forceUpdate = false) {

            const forceUpdate = _forceUpdate
            console.log("connection_test", this.team_slugname?? 'noname')

            // if (this.team_slugname) {
            //     if (this.team_slugname === "mondaycom" || this.team_slugname === "zest") {
            //         forceUpdate = true
            //     }
            // }

            if (this.is_registered && !forceUpdate) {
                //this.should_test_in_loop = false;
                clearTimeout(this.test_loop);
                this.is_loading = false;
                console.log("connection_test stop")
                return
            }


            //console.log("this.channel = ", this.channel)
            if (this.channel == "native_messaging" || this.channel == "api") {
                this.chat_id = this.ticket.id + "_native_messaging"
            }

            let url = this.$page.props.app_url + '/zendeskapp/auth/' + this.subdomain;
            //let url = 'https://zest.eu.ngrok.io/zendeskapp/auth/'+this.subdomain;
            var params = {
                location: this.location,
                secret: this.secret,
                tid: this.ticket.id,
                rid: this.ticket.custom_field_value,
                chat: this.is_zopim,
                cid: this.chat_id,
            };
            if (this.is_zopim) {
                params.zopim = "zopim"
            }

            if (this.location == 'ticket_editor' || this.location == 'chat_sidebar') {
                params.agent = {
                    id: this.agent.id,
                    email: this.agent.email,
                    name: this.encode_utf8(this.agent.name),
                    timezone: this.agent.timeZone.ianaName
                }
                // const encoder = new TextEncoder();
                // const utf8Arr = encoder.encode(this.agent.name);
            }


            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        console.log("connection_test response", response.data)
                        if (response.data.team_slug) {
                            if (response.data.user_not_provisionned) {
                                this.user_not_provisionned = true
                                return
                            }
                            this.team_slug = response.data.team_slug;
                            this.team_slugname = response.data.team_slugname;
                            this.integration_id = response.data.integration;
                            this.has_cobrowsing = response.data.has_cobrowsing;
                            this.has_screenrecording = response.data.has_screenrecording;
                            if (!this.has_screenrecording) {
                                this.agents_can = 'none'
                            }
                            // setKey("team_slug", response.data.team_slug);
                            // setKey("team_slugname", response.data.team_slugname);
                            // setKey("integration_id", response.data.integration);
                            this.has_zest_integration = true;
                            this.has_zest_account = true;
                            this.is_registered = true;
                            this.is_loading = false;
                            //this.should_test_in_loop = false;


                            if (this.team_slug && this.team_slugname && this.integration_id) {
                                setKey("zest_identification-agent_" + this.agent.id,
                                    JSON.stringify(response.data)
                                ).then((result) => {
                                    // ok
                                });
                            }

                        }
                    }
                })
                .catch(e => {
                    console.error("zest response error", e);
                    //this.has_match_error = true;
                    this.is_loading = false;
                    // if (this.should_test_in_loop) {
                    //   this.test_loop = setTimeout(function() {
                    //     this.connection_test();
                    //   }.bind(this), 5000);
                    // }
                    if (e.response.status == 400) {
                        this.must_reconnect = true
                        deleteKey("zest_identification-agent_" + this.agent.id).then((result) => {
                            // ok
                        })
                    } else if (e.response.status == 403) {
                        this.must_reconnect = true
                    }
                });
        },
        saveTinyAndSend: function (the_link) {
            let url = this.$page.props.app_url + '/tinyurl/save';
            var params = {
                data: the_link,
                team_slug: this.team_slug
            }
            axios.post(url, params)
                .then(response => {
                    if (response.data) {
                        if (response.data.tinyurl) {
                            //if (response.data.data.tinyurl) {
                            this.tinyurl = response.data.tinyurl
                            this.ask_recording_loading = false
                            this.ask_for_a_recording()
                            //}
                        }
                        if (response.data.team_slug_fix && response.data.team_slug_fix != this.team_slug) {
                            this.team_slug_fix = response.data.team_slug
                            this.connection_test(true)
                        }
                    }
                })
                .catch(e => {
                    console.error(e)
                    this.ask_recording_loading = false
                });
        },

        register_agent: function () {
            let url = this.$page.props.app_url + '/zendeskapp/register_agent';
            var params = {
                agent: this.agent,
                integration_id: this.integration_id,
                team_slug: this.team_slug,
                subdomain: this.subdomain,
            }
            axios.post(url, params)
                .then(response => {
                    if (response.data) {

                    }
                })
                .catch(e => {
                    console.error(e);
                });
        },

        // disable this, looks like it breaks things
        encode_utf8: function (s) {
            return s;// unescape( encodeURIComponent( s ) );
        },
        decode_utf8: function (s) {
            return s;// decodeURIComponent( escape( s ) );
        },


        hasNonASCIICharacters: function (str) {
            return /[^\x00-\x7F]/.test(str); // Matches any character outside the ASCII range
        },


    },

    computed: {
        cobrowsingLink: function () {
            var query = ""
            if (this.requester.email) {
                query = this.requester.email
            } else if (this.requester.externalId) {
                query = this.requester.externalId
            } else if (this.requester.name) {
                query = this.requester.name
            } else if (this.requester.id) {
                query = this.requester.id
            }
            if (query == "") {
                return this.$page.props.app_url + "/cobrowsing"
            }
            return this.$page.props.app_url + '/cobrowsing/zendesk?q=' + encodeURI(query)
        },
        agent_role: function () {
            if (this.agent) {
                return this.agent.role;
            }
            return "";
        },
        secret: function () {
            if (this.metadata) {
                if (this.metadata.appId && this.metadata.installationId) {
                    return this.metadata.appId + "_" + this.metadata.installationId;
                }
            }
            return "";
        },
        login_url: function () {
            var zc = {
                subdomain: this.subdomain,
                appId: this.metadata.appId,
                installationId: this.metadata.installationId,
                agent_email: this.agent.email,
                agent_name: this.agent.name,
                agent_timezone: this.agent.timeZone.ianaName,
                brand_name: "",
                brand_logo: ""
            }
            if (this.ticket.brand) {
                if (this.ticket.brand.name) {
                    zc.brand_name = this.encode_utf8(this.ticket.brand.name);
                }
                if (this.ticket.brand.logo) {
                    if (this.ticket.brand.logo.contentUrl) {
                        zc.brand_logo = this.ticket.brand.logo.contentUrl;
                    }
                }
            }
            zc = btoa(unescape(encodeURIComponent(JSON.stringify(zc))));
            let secure_zc = this.secureCode(zc);
            //return 'https://app.birdie.so/zendesk/install/' + secure_zc
            return this.$page.props.app_url + '/zendesk/install/' + secure_zc
        },

        send_recording_url: function () {
            if ((!this.ticket.id && !this.is_zopim) && (!this.chat_id && this.is_zopim)) {
                return "#";
            }
            if (this.ticket.id == 0 && !this.is_zopim) {
                return "#";
            }

            var the_link = this.$page.props.app_url.replace(this.$page.props.app_url, "https://" + this.team_slugname + "." + this.domain) + "/recorder";

            if (this.team_slugname == 'zest') {
                console.log("requester is", this.requester)
                console.log("agent is", this.agent)
            }

            let agentName = this.agent.name
            if (this.hasNonASCIICharacters(agentName) && this.agent.email) {
                agentName = this.agent.email.split("@")[0]
            }

            var agentLight = {
                id: this.agent.id,
                email: this.agent.email,
                name: agentName,
                locale: this.agent.locale,
                isSystemUser: this.agent.isSystemUser,
                externalId: this.agent.externalId,
                role: this.agent.role,
                avatarUrl: this.agent.avatarUrl,
                timeZone: {
                    ianaName: this.agent.timeZone.ianaName
                }
            }

            let reqName = this.requester.name
            if (this.hasNonASCIICharacters(reqName) && this.requester.email) {
                reqName = this.requester.email.split("@")[0]
            }

            var requesterLight
            if (!this.is_zopim) {
                requesterLight = {
                    id: this.requester.id,
                    email: this.requester.email,
                    name: reqName,
                    locale: this.requester.locale,
                    isSystemUser: this.requester.isSystemUser,
                    externalId: this.requester.externalId,
                    role: this.requester.role,
                    // avatarUrl: this.requester.avatarUrl,
                    timeZone: {
                        ianaName: this.requester.timeZone.ianaName
                    },
                    tags: this.requester.tags?.join(",")
                }
            } else {
                requesterLight = {
                    id: this.requester.id,
                    email: this.requester.email,
                    name: reqName,
                    //locale: this.requester.locale,
                    //isSystemUser: this.requester.isSystemUser,
                    externalId: this.requester.externalId,
                    tags: this.requester.tags?.join(",")
                    // role: this.requester.role,
                    // avatarUrl: this.requester.avatarUrl,
                    // timeZone: {
                    //     ianaName: this.requester.timeZone.ianaName
                    // }
                }
            }

            if (this.channel == "native_messaging" || this.channel == "api") {
                this.chat_id = this.ticket.id + "_native_messaging"
            }



            if (this.$page.props.isz) {
                console.log("channel", this.channel)
                console.log("ticket.id", this.ticket.id)
                console.log("chat_id", this.chat_id)
            }


            var zid = {
                s1: this.subdomain,
                s2: this.metadata.appId,
                s3: this.metadata.installationId,
                s4: this.ticket.id ? this.ticket.id : 0,
                s5: JSON.stringify(requesterLight),
                s6: JSON.stringify(agentLight),
                s8: this.chat_id,
                s9: this.channel
            }

            // zid = this.toBase64(JSON.stringify(zid));
            zid = btoa(unescape(encodeURIComponent(JSON.stringify(zid))));
            let secure_zid = this.secureCode(zid);
            the_link += "?zid=" + encodeURI(secure_zid);
            //the_link += "&rid=" + this.ticket.randomId;
            if (this.$page.props.app_url.indexOf(".test") >= 0) {
                the_link += "&team=" + this.team_slugname; // DEBUG
            }
            return the_link;
        }


    },

    // toBase64: function (str) {
    //     return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
    //         String.fromCharCode(parseInt(p1, 16))
    //     ));
    // }

}

</script>

<style scoped scss>
.box {
    padding: 0;
    color: #2f3941;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", Arial, sans-serif;
}

.box strong,
.box a {
    color: #2f3941;
}

.box a.button,
.box a.button:hover {
    color: #FFF;
    text-decoration: none;
}

.box.ticket_editor .preStuff {
    margin-top: 50px;
}

.stuffContainer {
    min-height: 100%;
    display: flex;
}

.stuffContainer>div {
    width: 100%;
}


.box.ticket_editor {
    background-position: center top;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(/img/iframe.png)
}

.sidebarlist a,
.editor a {
    color: #2F3941;
    display: block;
    text-decoration: none;
    font-size: 0.75rem;
    padding: 8px 0 8px 8px;
    border-bottom: 1px solid rgb(233, 235, 237);
}

.editor a {
    height: 40px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.sidebarlist a:hover,
.editor a:hover {
    background: #F8F9F9;
}

.sidebarlist a:last-child,
.editor a:last-child {
    border-bottom: 1px solid transparent;
}

.sidebarlist a .block,
.editor a .block {
    margin: 0;
    padding: 0;
}

.block.title {
    font-size: 0.8rem;
    padding-left: 8px;
}

.block.novideo {
    font-size: 0.75rem;
}

a.action,
a.action:hover,
a.action:active,
div.no_requester {
    padding-left: 43px;
    background-position: 6px center;
    background-repeat: no-repeat;
    background-size: auto 30px;
}

a.action:hover {
    background-repeat: no-repeat;
}

a.action.ask {
    background-image: url('/img/birdie_icon_ask.png');
}

a.action.record {
    background-image: url('/img/birdie_icon_send.png');
}

a.action.cobrowse {
    background-image: url('/img/birdie_icon_corowse.png');
}

a.action.record.error_send {
    background-image: none;
    padding-left: 0;
}


a.action.help {
    color: #425DF2;
    padding-right: 8px;
    background: none;
}

a.action.help strong {
    color: #425DF2;
}

a.action.help:hover {
    background-color: transparent;
}

a.action.help:hover strong {
    color: #244DE1;
}

.editorPopTitle {
    color: #2F3941;
    position: absolute;
    top: 10px;
    left: 19px;
    font-weight: bold;
    font-size: 15px;
}

.editor a.action,
.editor a.action:hover,
.editor a.action:active {
    background-position: 11px center;
}

.helpfooter {
    position: absolute;
    bottom: 0;
    width: 100%;
    font-size: 12px;
    background: #FFF;
    padding: 3px 0 0 0;
}

.helpfooter a {
    color: #1f73b7;
    text-decoration: none;
}

.helpfooter a:hover {
    text-decoration: underline;
}
</style>
